"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2426],{

/***/ 5249:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function processText(text) {
    var parts = [];
    var UrlReg = /https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)/gi;
    var match = UrlReg.exec(text);
    var lastIndex = 0;
    while(match){
        if (match.index > lastIndex) {
            parts.push({
                type: "text",
                text: text.slice(lastIndex, match.index)
            });
            lastIndex = match.index;
        }
        var url = match[0];
        lastIndex += url.length;
        parts.push({
            type: "link",
            link: url,
            text: new URL(url).host
        });
        match = UrlReg.exec(text);
    }
    if (text.slice(lastIndex)) {
        parts.push({
            type: "text",
            text: text.slice(lastIndex)
        });
    }
    return parts;
}
var RichText = function RichText(param) {
    var text = param.text, className = param.className;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), parts = ref[0], setParts = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setParts(processText(text || ""));
    }, [
        text
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat(className),
        children: parts.map(function(part, index) {
            if (part.type === "text") {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    children: part.text
                }, index);
            } else if (part.type === "link") {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    href: part.link,
                    className: "action !text-primary ",
                    target: "_blank",
                    rel: "noreferrer",
                    children: part.text
                }, index);
            } else {
                return null;
            }
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (RichText);


/***/ }),

/***/ 36005:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _utils_format__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6767);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);



var CaptainListCard = function CaptainListCard(param) {
    var validator = param.validator, itemWidth = param.itemWidth, onEvent = param.onEvent, dataKey = param.dataKey;
    var ref, ref1, ref2;
    var image = validator.avatar || validator.imageUrl;
    var width = itemWidth || 150;
    var height = width * 1.2;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-col justify-between bg-cover border border-[#E0E1E1]  rounded-lg overflow-hidden group cursor-pointer relative min-h-[10vw] transition-all  ".concat(itemWidth > 50 ? "" : "opacity-0"),
        style: {
            width: width
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                className: "rounded-lg overflow-hidden",
                src: image || "/karatdao.jpg",
                layout: "fixed",
                loading: "lazy",
                width: width,
                height: width,
                placeholder: "blur",
                objectFit: "cover",
                blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNcVQoAAc8BIaDXu+0AAAAASUVORK5CYII="
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex justify-between p-2 absolute top-0 left-0 w-full",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "p-1 bg-white/50 rounded-[4px] text-dark1 text-sm",
                    style: {
                        backdropFilter: "blur(5px)"
                    },
                    children: [
                        "#",
                        validator.tokenId
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "p-4 flex flex-col gap-2",
                children: [
                    validator.validatorName && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "font-semibold text-sm",
                        children: validator.validatorName
                    }),
                    dataKey === "stakedAmount" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex justify-between bg-white/75 w-full",
                        style: {
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "w-full leading-none",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex justify-between items-center text-sm",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "text-sm",
                                            children: [
                                                (0,_utils_format__WEBPACK_IMPORTED_MODULE_1__/* .amountDesc */ .sB)(parseFloat(validator.stake.stakedAmount), 2),
                                                " KAT"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "text-sm text-right",
                                            children: [
                                                (0,_utils_format__WEBPACK_IMPORTED_MODULE_1__/* .amountDesc */ .sB)(parseFloat(((ref = validator.stake) === null || ref === void 0 ? void 0 : ref.lastDayReturn) || "0")) || "0",
                                                " ",
                                                "KAT"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex justify-between items-center text-xs",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "text-[#585858] text-xs",
                                            children: "Staked"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "text-[#585858] text-xs whitespace-nowrap",
                                            children: "Last day return"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    (dataKey === "apy" || dataKey === "lastDayReturn" || dataKey === "tokenId") && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex justify-between bg-white/75 w-full",
                        style: {
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "w-full leading-none",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex justify-between items-center text-sm",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "text-sm",
                                            children: [
                                                ((validator.stake.apy || 0) * 100).toFixed(2),
                                                "%",
                                                " "
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "text-sm text-right",
                                            children: [
                                                (0,_utils_format__WEBPACK_IMPORTED_MODULE_1__/* .amountDesc */ .sB)(parseFloat(((ref1 = validator.stake) === null || ref1 === void 0 ? void 0 : ref1.lastDayReturn) || "0")) || "0",
                                                " ",
                                                "KAT"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex justify-between items-center text-xs",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "text-[#585858] text-xs",
                                            children: "APY"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "text-[#585858] text-xs whitespace-nowrap",
                                            children: "Last day return"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    dataKey === "earnings" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex justify-between bg-white/75 w-full",
                        style: {
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "w-full flex items-center justify-between text-sm leading-none",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    children: [
                                        ((validator.stake.apy || 0) * 100).toFixed(2),
                                        "% APY"
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "font-semibold",
                                    children: [
                                        (0,_utils_format__WEBPACK_IMPORTED_MODULE_1__/* .numberWithCommas */ .x6)(parseFloat(((ref2 = validator.userStake) === null || ref2 === void 0 ? void 0 : ref2.stakedAmount) || "0")),
                                        " ",
                                        "KAT"
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "group-hover:opacity-100 opacity-0 flex absolute w-full h-full left-0 top-0 bg-black/50 rounded-lg items-center justify-center transition-all",
                style: {
                    backdropFilter: "blur(1px)"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "px-4 flex flex-col items-center gap-2",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-[140px] h-[40px] flex items-center justify-center rounded-full bg-primary text-white text-xs font-semibold cursor-pointer transition-all hover:scale-[0.95]",
                        onClick: function() {
                            onEvent(validator.tokenId, "view_detail");
                        },
                        children: "Stake more"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CaptainListCard);


/***/ }),

/***/ 66636:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ staking_ValidatorStakeDrawer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/utils/format.ts
var format = __webpack_require__(6767);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Drawer/Drawer.js + 4 modules
var Drawer = __webpack_require__(92716);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/LoadingOverlay/LoadingOverlay.js + 1 modules
var LoadingOverlay = __webpack_require__(49737);
// EXTERNAL MODULE: ./src/hooks/useDevice.tsx
var useDevice = __webpack_require__(65416);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Button/Button.js + 3 modules
var Button = __webpack_require__(67841);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/NumberInput/NumberInput.js + 4 modules
var NumberInput = __webpack_require__(36176);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/SegmentedControl/SegmentedControl.js + 1 modules
var SegmentedControl = __webpack_require__(73819);
// EXTERNAL MODULE: ./src/hooks/useAccount.tsx
var useAccount = __webpack_require__(98786);
// EXTERNAL MODULE: ./src/hooks/useRequest.tsx
var useRequest = __webpack_require__(21706);
// EXTERNAL MODULE: ./node_modules/bignumber.js/bignumber.mjs
var bignumber = __webpack_require__(70794);
// EXTERNAL MODULE: ./node_modules/@wagmi/core/dist/chunk-LAFZBYO7.js + 71 modules
var chunk_LAFZBYO7 = __webpack_require__(17276);
// EXTERNAL MODULE: ./node_modules/wagmi/dist/index.js + 25 modules
var dist = __webpack_require__(69077);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs
var react_toastify_esm = __webpack_require__(55678);
// EXTERNAL MODULE: ./node_modules/viem/dist/esm/utils/unit/parseUnits.js
var parseUnits = __webpack_require__(22852);
// EXTERNAL MODULE: ./node_modules/viem/dist/esm/utils/unit/parseEther.js
var parseEther = __webpack_require__(58903);
// EXTERNAL MODULE: ./src/services/contract.ts + 10 modules
var contract = __webpack_require__(26720);
// EXTERNAL MODULE: ./src/utils/validate.ts
var validate = __webpack_require__(68974);
// EXTERNAL MODULE: ./src/services/events.ts
var events = __webpack_require__(76029);
;// CONCATENATED MODULE: ./src/hooks/staking/useStakeContract.ts
















function useStakeContract(validatorId) {
    var ref = (0,useAccount/* default */.Z)(), address = ref.address, balance = ref.balance, login = ref.login;
    var switchNetworkAsync = (0,dist/* useSwitchNetwork */.g0)().switchNetworkAsync;
    var chain = (0,dist/* useNetwork */.LN)().chain;
    var ref1 = (0,react.useState)(false), staking = ref1[0], setStaking = ref1[1];
    var ref2 = (0,react.useState)(false), unStaking = ref2[0], setUnStaking = ref2[1];
    var unStakeBatch = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(tokenIds) {
            var resp, e, e1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (tokenIds.length === 0) {
                            return [
                                2
                            ];
                        }
                        if (!address) {
                            return [
                                2,
                                login()
                            ];
                        }
                        if (unStaking) {
                            return [
                                2
                            ];
                        }
                        setUnStaking(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            10,
                            11,
                            12
                        ]);
                        if (!switchNetworkAsync) {
                            return [
                                2
                            ];
                        }
                        if (!((chain === null || chain === void 0 ? void 0 : chain.id) !== contract/* stakingContractInfo.chainId */.en.chainId)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            switchNetworkAsync(contract/* stakingContractInfo.chainId */.en.chainId)
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        return [
                            4,
                            (0,chunk_LAFZBYO7/* writeContract */.n9)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, contract/* stakingContractInfo */.en), {
                                functionName: "unstakeBatch",
                                args: [
                                    tokenIds.map(function(id) {
                                        return Number(id);
                                    })
                                ]
                            }))
                        ];
                    case 4:
                        resp = _state.sent();
                        _state.label = 5;
                    case 5:
                        _state.trys.push([
                            5,
                            7,
                            ,
                            9
                        ]);
                        return [
                            4,
                            (0,chunk_LAFZBYO7/* waitForTransaction */.Mn)({
                                hash: resp.hash,
                                confirmations: 6
                            })
                        ];
                    case 6:
                        _state.sent();
                        return [
                            3,
                            9
                        ];
                    case 7:
                        e = _state.sent();
                        return [
                            4,
                            (0,validate/* isSkipError */.D0)(e)
                        ];
                    case 8:
                        if (!_state.sent()) {
                            throw e;
                        }
                        return [
                            3,
                            9
                        ];
                    case 9:
                        events/* default.emit */.Z.emit("unStakeBatchSuccess", {
                            validatorId: validatorId,
                            tokenIds: tokenIds,
                            address: address
                        });
                        react_toastify_esm/* toast.success */.Am.success("Un-stake success");
                        return [
                            2,
                            true
                        ];
                    case 10:
                        e1 = _state.sent();
                        if ((0,validate/* isUserRejectError */.Qd)(e1)) {
                            return [
                                2,
                                false
                            ];
                        }
                        console.error(e1);
                        react_toastify_esm/* toast.error */.Am.error(e1.message);
                        throw new Error(e1.message);
                    case 11:
                        setUnStaking(false);
                        return [
                            7
                        ];
                    case 12:
                        return [
                            2
                        ];
                }
            });
        });
        return function(tokenIds) {
            return _ref.apply(this, arguments);
        };
    }(), [
        chain,
        switchNetworkAsync,
        unStaking,
        validatorId,
        address,
        login
    ]);
    var stake = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(amount) {
            var data, allowance, resp, e, resp1, e1, e2;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (staking) {
                            return [
                                2
                            ];
                        }
                        if (!address) {
                            return [
                                2,
                                login()
                            ];
                        }
                        setStaking(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            17,
                            18,
                            19
                        ]);
                        if (new bignumber/* default */.Z(amount).isGreaterThan(balance)) {
                            throw new Error("Insufficient balance");
                        }
                        if (!switchNetworkAsync) {
                            return [
                                2
                            ];
                        }
                        if (!((chain === null || chain === void 0 ? void 0 : chain.id) !== contract/* stakingContractInfo.chainId */.en.chainId)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            switchNetworkAsync(contract/* stakingContractInfo.chainId */.en.chainId)
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        return [
                            4,
                            (0,chunk_LAFZBYO7/* readContract */.a4)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, contract/* KATContractInfo */.Fr), {
                                functionName: "allowance",
                                args: [
                                    address,
                                    contract/* stakingContractInfo.address */.en.address
                                ]
                            }))
                        ];
                    case 4:
                        data = _state.sent();
                        allowance = (data || 0n) / BigInt(1e18);
                        if (!(allowance < BigInt(amount))) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            (0,chunk_LAFZBYO7/* writeContract */.n9)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, contract/* KATContractInfo */.Fr), {
                                functionName: "approve",
                                args: [
                                    contract/* stakingContractInfo.address */.en.address,
                                    (0,parseUnits/* parseUnits */.v)(String(amount), 18)
                                ]
                            }))
                        ];
                    case 5:
                        resp = _state.sent();
                        _state.label = 6;
                    case 6:
                        _state.trys.push([
                            6,
                            8,
                            ,
                            10
                        ]);
                        return [
                            4,
                            (0,chunk_LAFZBYO7/* waitForTransaction */.Mn)({
                                hash: resp.hash
                            })
                        ];
                    case 7:
                        _state.sent();
                        return [
                            3,
                            10
                        ];
                    case 8:
                        e = _state.sent();
                        return [
                            4,
                            (0,validate/* isSkipError */.D0)(e)
                        ];
                    case 9:
                        if (!_state.sent()) {
                            throw e;
                        }
                        return [
                            3,
                            10
                        ];
                    case 10:
                        return [
                            4,
                            (0,chunk_LAFZBYO7/* writeContract */.n9)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, contract/* stakingContractInfo */.en), {
                                functionName: "stake",
                                args: [
                                    (0,parseEther/* parseEther */.f)(String(amount)),
                                    parseInt(validatorId)
                                ]
                            }))
                        ];
                    case 11:
                        resp1 = _state.sent();
                        _state.label = 12;
                    case 12:
                        _state.trys.push([
                            12,
                            14,
                            ,
                            16
                        ]);
                        return [
                            4,
                            (0,chunk_LAFZBYO7/* waitForTransaction */.Mn)({
                                hash: resp1.hash,
                                confirmations: 6
                            })
                        ];
                    case 13:
                        _state.sent();
                        return [
                            3,
                            16
                        ];
                    case 14:
                        e1 = _state.sent();
                        return [
                            4,
                            (0,validate/* isSkipError */.D0)(e1)
                        ];
                    case 15:
                        if (!_state.sent()) {
                            throw e1;
                        }
                        return [
                            3,
                            16
                        ];
                    case 16:
                        events/* default.emit */.Z.emit("stakeSuccess", {
                            validatorId: validatorId,
                            amount: amount,
                            address: address
                        });
                        react_toastify_esm/* toast.success */.Am.success("Stake success");
                        return [
                            2,
                            true
                        ];
                    case 17:
                        e2 = _state.sent();
                        if ((0,validate/* isUserRejectError */.Qd)(e2)) {
                            return [
                                2
                            ];
                        }
                        console.error(e2);
                        react_toastify_esm/* toast.error */.Am.error(e2.message);
                        throw new Error(e2.message);
                    case 18:
                        setStaking(false);
                        return [
                            7
                        ];
                    case 19:
                        return [
                            2
                        ];
                }
            });
        });
        return function(amount) {
            return _ref.apply(this, arguments);
        };
    }(), [
        chain,
        switchNetworkAsync,
        staking,
        validatorId,
        balance,
        address,
        login
    ]);
    return {
        stake: stake,
        staking: staking,
        unStakeBatch: unStakeBatch,
        unStaking: unStaking
    };
}

// EXTERNAL MODULE: ./src/components/common/icons.tsx
var icons = __webpack_require__(58163);
// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-disclosure/use-disclosure.js
var use_disclosure = __webpack_require__(91759);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Table/Table.js + 1 modules
var Table = __webpack_require__(95078);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
;// CONCATENATED MODULE: ./src/components/network/staking/UnStakeList.tsx




var UnStakeList = function(param) {
    var items = param.items;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-white rounded-lg py-4 px-6 max-h-[128px] overflow-y-scroll",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table/* Table */.i, {
            fontSize: "xs",
            verticalSpacing: "xs",
            horizontalSpacing: "xs",
            className: "un-stake-table",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                className: "w-[43%]",
                                children: "Amount"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                children: "Available on"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {})
                            ]
                        }),
                        items.sort(function(a, b) {
                            return a.unLockTime - b.unLockTime;
                        }).map(function(item) {
                            var isAvailable = item.unLockTime <= Date.now();
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                        children: [
                                            (0,format/* numberWithCommas */.x6)(parseFloat(item.stakedAmount)),
                                            " KAT"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: isAvailable ? "Available now" : dayjs_min_default()(item.unLockTime).format("M/D/YYYY [at] hA")
                                    })
                                ]
                            }, item.tokenId);
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var staking_UnStakeList = (UnStakeList);

;// CONCATENATED MODULE: ./src/hooks/staking/useUserStakingRewards.ts







function useUserStakingRewards(tokenIds) {
    var ref = (0,react.useState)([]), rewards = ref[0], setRewards = ref[1];
    var refetch = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(_tokenIds) {
            var idList, rewards, chunkSize, i, chunk, res;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        idList = _tokenIds || tokenIds;
                        rewards = [];
                        chunkSize = 10;
                        i = 0;
                        _state.label = 1;
                    case 1:
                        if (!(i < idList.length)) return [
                            3,
                            4
                        ];
                        chunk = idList.slice(i, i + chunkSize);
                        return [
                            4,
                            (0,chunk_LAFZBYO7/* readContract */.a4)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                functionName: "calculateRewardsEarnedBatch"
                            }, contract/* stakingContractInfo */.en), {
                                args: [
                                    chunk.map(function(id) {
                                        return Number(id);
                                    })
                                ]
                            }))
                        ];
                    case 2:
                        res = _state.sent();
                        rewards = rewards.concat(res);
                        _state.label = 3;
                    case 3:
                        i += chunkSize;
                        return [
                            3,
                            1
                        ];
                    case 4:
                        setRewards(rewards);
                        return [
                            2
                        ];
                }
            });
        });
        return function(_tokenIds) {
            return _ref.apply(this, arguments);
        };
    }(), [
        tokenIds
    ]);
    (0,react.useEffect)(function() {
        refetch(tokenIds);
    }, [
        tokenIds
    ]);
    return {
        refetch: refetch,
        rewards: rewards
    };
}

// EXTERNAL MODULE: ./src/hooks/staking/useRewardContract.ts
var useRewardContract = __webpack_require__(55562);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Modal/Modal.js + 4 modules
var Modal = __webpack_require__(94491);
// EXTERNAL MODULE: ./node_modules/react-icons/ai/index.esm.js
var index_esm = __webpack_require__(8193);
;// CONCATENATED MODULE: ./src/components/network/staking/StakeRulesDialog.tsx



var StakeRulesDialog = function(param) {
    var opened = param.opened, onClose = param.onClose, onAgree = param.onAgree;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* Modal */.u, {
        opened: opened,
        onClose: onClose,
        withCloseButton: false,
        centered: true,
        size: 400,
        radius: 16,
        zIndex: 999,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "pt-5 pb-5 relative px-5 flex flex-col items-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlineCloseCircle */.SV5, {
                    size: 26,
                    className: "fill-primary action absolute right-0 top-0",
                    onClick: onClose
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "font-semibold text-lg",
                    children: "Staking Rules"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "whitespace-pre-line mt-10 text-xs",
                    children: "1. You will only be allowed to unstake after 48 hours. When you unstake, a 5% fee in KAT tokens will be automatically burned.\n\n2. Staking rewards can be claimed daily at 3:00 PM Pacific Time (T+2). Claiming staking rewards will result in the burning of 5% of KAT."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center justify-center gap-8 mt-10",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            size: "md",
                            radius: "xl",
                            className: "sm:w-[149px] bg-[#E0E1E1] text-dark2 hover:bg-[#E0E1E1]",
                            onClick: onClose,
                            children: "cancel"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            size: "md",
                            radius: "xl",
                            className: "sm:w-[149px]",
                            onClick: function() {
                                onClose();
                                onAgree();
                            },
                            children: "I agree"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var staking_StakeRulesDialog = (StakeRulesDialog);

;// CONCATENATED MODULE: ./src/components/leaderboard/UserStakeCard.tsx





















var UserStakeCard = function UserStakeCard(param) {
    var className = param.className, tokenId = param.tokenId;
    var ref = (0,react.useState)(false), focus = ref[0], setFocus = ref[1];
    var ref1 = (0,react.useState)(true), invested = ref1[0], setInvested = ref1[1];
    var ref2 = (0,react.useState)(undefined), investValue = ref2[0], setInvestValue = ref2[1];
    var ref3 = (0,react.useState)(""), investError = ref3[0], setInvestError = ref3[1];
    var ref4 = (0,react.useState)("stake"), tab = ref4[0], setTab = ref4[1];
    var ref5 = (0,useAccount/* default */.Z)(), address = ref5.address, login = ref5.login, balance = ref5.balance, setBalance = ref5.setBalance;
    var ref6 = useStakeContract(String(tokenId)), stake = ref6.stake, staking = ref6.staking, unStakeBatch = ref6.unStakeBatch, unStaking = ref6.unStaking;
    var ref7 = (0,react.useState)((0,bignumber/* default */.Z)(0)), unStakeAmount = ref7[0], setUnStakeAmount = ref7[1];
    var ref8 = (0,react.useState)([]), tokenIds = ref8[0], setTokenIds = ref8[1];
    var ref9 = (0,react.useState)([]), availableTokenIds = ref9[0], setAvailableTokenIds = ref9[1];
    var ref10 = (0,_sliced_to_array/* default */.Z)((0,use_disclosure/* useDisclosure */.q)(false), 2), unStakeRecordShowed = ref10[0], toggle = ref10[1].toggle;
    var ref11 = useUserStakingRewards(tokenIds), refreshRewards = ref11.refetch, rewards = ref11.rewards;
    var ref12 = (0,react.useState)(new bignumber/* default */.Z(0)), earningAmount = ref12[0], setEarningAmount = ref12[1];
    var ref13 = (0,useRewardContract/* default */.Z)(), claimStakerBatch = ref13.claimStakerBatch, claiming = ref13.claiming;
    var ref14 = (0,_sliced_to_array/* default */.Z)((0,use_disclosure/* useDisclosure */.q)(false), 2), isStakeRuleDialogOpen = ref14[0], ref15 = ref14[1], openStakeRuleDialog = ref15.open, closeStakeRuleDialog = ref15.close;
    (0,react.useEffect)(function() {
        var earningAmount = rewards.reduce(function(total, val) {
            if (String(val).length > 36) {
                return total.plus(new bignumber/* default */.Z(String(val)).div(1e18).div(1e18));
            } else {
                return total.plus(new bignumber/* default */.Z(String(val)).div(1e18));
            }
        }, new bignumber/* default */.Z(0));
        setEarningAmount(earningAmount);
    }, [
        rewards
    ]);
    var ref16 = (0,useRequest/* default */.Z)(address && typeof tokenId !== "undefined" ? {
        function: "stake/getUserStakeInfo",
        data: {
            address: address,
            validatorId: String(tokenId)
        }
    } : null), userStakeInfo = ref16.data, mutate = ref16.mutate;
    var onStake = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var stakeRes;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!investValue) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        stake(investValue)
                    ];
                case 1:
                    stakeRes = _state.sent();
                    if (stakeRes === true) {
                        mutate(userStakeInfo ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, userStakeInfo), {
                            stakedAmount: new bignumber/* default */.Z(userStakeInfo.stakedAmount).plus(investValue).toString()
                        }) : undefined, {
                            revalidate: false
                        });
                        setBalance(balance.minus(investValue));
                    }
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    }), [
        investValue,
        stake,
        mutate,
        userStakeInfo,
        setBalance,
        balance
    ]);
    var onBeforeStake = (0,react.useCallback)(function() {
        if (investValue) {
            openStakeRuleDialog();
        }
    }, [
        investValue,
        openStakeRuleDialog
    ]);
    var onUnStake = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var unStakeRes;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (earningAmount.isGreaterThan(0)) {
                        setTab("claim");
                        react_toastify_esm/* toast.info */.Am.info("You must claim earnings before Un-stake");
                        return [
                            2
                        ];
                    }
                    if (!(availableTokenIds.length > 0)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        unStakeBatch(availableTokenIds.slice(0, 10))
                    ];
                case 1:
                    unStakeRes = _state.sent();
                    if (unStakeRes === true) {
                        mutate(userStakeInfo ? {
                            stakedAmount: new bignumber/* default */.Z(userStakeInfo.stakedAmount).minus(unStakeAmount).toString(),
                            stakeList: userStakeInfo.stakeList.filter(function(item) {
                                return !availableTokenIds.slice(0, 10).includes(item.tokenId);
                            })
                        } : undefined, {
                            revalidate: false
                        });
                        setBalance(balance.plus(unStakeAmount.multipliedBy(0.95)));
                    }
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    }), [
        unStakeBatch,
        mutate,
        availableTokenIds,
        earningAmount,
        userStakeInfo,
        unStakeAmount,
        setBalance,
        balance, 
    ]);
    var onClaim = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var idList, claimRes;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    idList = [];
                    rewards.forEach(function(val, index) {
                        if (val !== 0n) {
                            idList.push(tokenIds[index]);
                        }
                    });
                    if (!(idList.length > 0)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        claimStakerBatch(idList.slice(0, 10))
                    ];
                case 1:
                    claimRes = _state.sent();
                    if (claimRes === true) {
                        setEarningAmount(new bignumber/* default */.Z(0));
                        setBalance(balance.plus(earningAmount.multipliedBy(0.95)));
                    }
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    }), [
        claimStakerBatch,
        tokenIds,
        refreshRewards,
        rewards,
        setEarningAmount,
        setBalance,
        balance,
        earningAmount, 
    ]);
    var stakedAmount = (0,format/* numberWithCommas */.x6)(new bignumber/* default */.Z((userStakeInfo === null || userStakeInfo === void 0 ? void 0 : userStakeInfo.stakedAmount) || "0").toNumber());
    (0,react.useEffect)(function() {
        var ref;
        var unStakeAmount = new bignumber/* default */.Z(0);
        var availableTokenIds = [];
        var tokenIds = [];
        userStakeInfo === null || userStakeInfo === void 0 ? void 0 : (ref = userStakeInfo.stakeList) === null || ref === void 0 ? void 0 : ref.forEach(function(item) {
            if (item.unLockTime <= Date.now()) {
                unStakeAmount = unStakeAmount.plus(new bignumber/* default */.Z(item.stakedAmount));
                availableTokenIds.push(item.tokenId);
            }
            tokenIds.push(item.tokenId);
        });
        setUnStakeAmount(unStakeAmount);
        setAvailableTokenIds(availableTokenIds);
        setTokenIds(tokenIds);
    }, [
        userStakeInfo
    ]);
    var unStakeAmountDesc = (0,format/* numberWithCommas */.x6)(unStakeAmount.toNumber());
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mt-6 bg-[#EBF3FF] relative rounded-lg w-full p-6 ".concat(className || ""),
        children: [
            !address && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute w-full h-full z-10 flex items-center justify-center left-0 top-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    radius: "xl",
                    size: "md",
                    onClick: login,
                    children: "Connect wallet"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat(address ? "" : "blur-sm"),
                children: [
                    invested && /*#__PURE__*/ (0,jsx_runtime.jsx)(SegmentedControl/* SegmentedControl */.s, {
                        className: "w-full mb-6",
                        radius: "md",
                        classNames: {
                            indicator: "border border-primary",
                            control: "!border-none ",
                            root: "bg-[#F9F9F9]"
                        },
                        size: "md",
                        value: tab,
                        onChange: setTab,
                        data: [
                            {
                                label: "Stake",
                                value: "stake"
                            },
                            {
                                label: "Un-stake",
                                value: "unstake"
                            },
                            {
                                label: "Claim",
                                value: "claim"
                            }, 
                        ]
                    }),
                    tab === "stake" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col items-center flex-1",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "font-bold text-xl text-tertiary",
                                                children: [
                                                    (0,format/* katAmountDesc */.rR)(Number(balance), 2),
                                                    " KAT"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-sm",
                                                children: "KAT balance"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "bg-[#87B5FF] w-[1px] h-10"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col items-center flex-1",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "font-bold text-xl text-tertiary",
                                                children: [
                                                    stakedAmount,
                                                    " KAT"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-sm",
                                                children: "Staked amount"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mt-6 !mb-0 flex items-center  px-3 border  border-solid  rounded ".concat(investError ? "input-error-block !bg-[rgba(250,82,82,0.10)] !border-error" : "", " ").concat(focus ? "form-focus-block" : "", " bg-white pt-2 pb-1"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex-1",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-dark1 text-bodyS font-semibold ".concat(investError ? "!text-error" : ""),
                                                children: "Staking amount"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex items-center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "mr-1 text-sm mt-[2px]",
                                                        children: "$"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NumberInput/* NumberInput */.Y, {
                                                        classNames: {
                                                            input: "!text-body !border-none !p-0 !bg-transparent",
                                                            wrapper: "!mb-0"
                                                        },
                                                        hideControls: true,
                                                        thousandsSeparator: ",",
                                                        step: 1,
                                                        value: investValue,
                                                        onChange: function(value) {
                                                            setInvestValue(value);
                                                            setInvestError("");
                                                        },
                                                        size: "xs",
                                                        autoComplete: "off",
                                                        spellCheck: false,
                                                        onFocus: function() {
                                                            setFocus(true);
                                                        },
                                                        onBlur: function() {
                                                            setFocus(false);
                                                        }
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-xs font-bold text-gray1 text-right",
                                        children: "KAT"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                className: "h-[56px] w-full mt-6",
                                radius: "xl",
                                loading: staking,
                                onClick: onBeforeStake,
                                disabled: "true" === "true",
                                children: "Stake"
                            }),
                             true && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-2 text-xs text-center max-w-[300px] mx-auto text-dark2",
                                children: "stake is temporarily unavailable while the contract upgrading"
                            })
                        ]
                    }),
                    tab === "unstake" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col items-center flex-1",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "font-bold text-xl text-tertiary",
                                            children: [
                                                unStakeAmountDesc,
                                                " KAT"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "text-sm flex items-center action select-none",
                                            onClick: toggle,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "Available to un-stake"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ArrowDownIcon */.ve, {
                                                    className: "w-2 ml-2 mt-1 transition-all origin-center ".concat(unStakeRecordShowed ? "rotate-180" : "")
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            unStakeRecordShowed && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(staking_UnStakeList, {
                                    items: (userStakeInfo === null || userStakeInfo === void 0 ? void 0 : userStakeInfo.stakeList) || []
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                className: "h-[56px] w-full mt-6",
                                radius: "xl",
                                loading: unStaking,
                                onClick: onUnStake,
                                disabled:  true || 0,
                                children: "Un-stake"
                            }),
                             true ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-2 text-xs text-center max-w-[300px] mx-auto text-dark2",
                                children: "unstake is temporarily unavailable while the contract upgrading"
                            }) : /*#__PURE__*/ 0
                        ]
                    }),
                    tab === "claim" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col items-center flex-1",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "font-bold text-xl text-tertiary break-all text-center",
                                            children: [
                                                (0,format/* katAmountDesc */.rR)(earningAmount.toNumber(), 2),
                                                " KAT"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-sm",
                                            children: "Total earnings"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                className: "h-[56px] w-full mt-6",
                                radius: "xl",
                                disabled:  true || 0,
                                loading: claiming,
                                onClick: onClaim,
                                children: "Claim"
                            }),
                             true ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-2 text-xs text-center max-w-[300px] mx-auto text-dark2",
                                children: "Claim is temporarily unavailable while the contract upgrading"
                            }) : /*#__PURE__*/ 0
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(staking_StakeRulesDialog, {
                opened: isStakeRuleDialogOpen,
                onClose: closeStakeRuleDialog,
                onAgree: onStake
            })
        ]
    });
};
/* harmony default export */ var leaderboard_UserStakeCard = (UserStakeCard);

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/common/RichText.tsx
var RichText = __webpack_require__(5249);
;// CONCATENATED MODULE: ./src/components/network/staking/ValidatorStakeDrawer.tsx








var ValidatorStakeDrawer = function(param) {
    var opened = param.opened, close = param.close, validator = param.validator;
    var ref, ref1, ref2, ref3;
    var isMobile = (0,useDevice/* useDevice */.F)().isMobile;
    var image = (validator === null || validator === void 0 ? void 0 : validator.avatar) || (validator === null || validator === void 0 ? void 0 : validator.imageUrl);
    var stakedAmount = new bignumber/* default */.Z((validator === null || validator === void 0 ? void 0 : (ref = validator.stake) === null || ref === void 0 ? void 0 : ref.stakedAmount) || 0);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Drawer/* Drawer */.d, {
        opened: opened,
        onClose: close,
        position: isMobile ? "bottom" : "right",
        trapFocus: false,
        size: 480,
        // overlayProps={{
        //   opacity: isMobile ? 0.6 : 0,
        // }}
        classNames: {
            content: "rounded-t-lg sm:rounded-l-lg"
        },
        styles: {
            content: {
                boxShadow: "-3px -3px 16px rgba(0, 0, 0, 0.05)"
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingOverlay/* LoadingOverlay */.f, {
                visible: !validator,
                overlayBlur: 4
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "px-8 flex flex-col items-center pb-10",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-lg font-semibold",
                        children: "Stake"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-6 p-6 border border-[#87B5FF] rounded-lg w-full",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full h-[195px] flex items-center justify-center bg-cover bg-center relative",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    className: "rounded-lg overflow-hidden",
                                    src: image || "/karatdao.jpg",
                                    layout: "fixed",
                                    height: 195,
                                    width: 195,
                                    loading: "lazy",
                                    placeholder: "blur",
                                    objectFit: "cover",
                                    blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNcVQoAAc8BIaDXu+0AAAAASUVORK5CYII="
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mt-8 font-semibold text-center",
                                children: [
                                    (validator === null || validator === void 0 ? void 0 : validator.validatorName) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: validator === null || validator === void 0 ? void 0 : validator.validatorName
                                    }),
                                    " ",
                                    "#",
                                    validator === null || validator === void 0 ? void 0 : validator.tokenId,
                                    " "
                                ]
                            }),
                            (validator === null || validator === void 0 ? void 0 : validator.description) && /*#__PURE__*/ (0,jsx_runtime.jsx)(RichText/* default */.Z, {
                                className: "mt-4 text-sm text-center whitespace-pre-line",
                                text: validator === null || validator === void 0 ? void 0 : validator.description
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mt-8 flex items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col items-center flex-1",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "font-bold text-xl text-tertiary",
                                                children: (0,format/* amountDesc */.sB)(stakedAmount.toNumber(), 2)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-sm",
                                                children: "KAT staked"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "h-10 w-[1px] bg-tertiary "
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col items-center flex-1",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "font-bold text-xl text-tertiary",
                                                children: [
                                                    (((validator === null || validator === void 0 ? void 0 : (ref1 = validator.stake) === null || ref1 === void 0 ? void 0 : ref1.percentageOfNetwork) || 0) * 100).toFixed(1),
                                                    " ",
                                                    "%"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-sm",
                                                children: "Of total network"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mt-8 gap-4 flex flex-col text-sm",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center justify-between text-dark1",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "font-semibold",
                                                children: "Address"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: (0,format/* etherscanAddressLink */.cO)(validator === null || validator === void 0 ? void 0 : validator.ownerAddress),
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    className: "text-primary text-sm action hover:text-primary",
                                                    children: (0,format/* trimAddr1 */.Cr)((validator === null || validator === void 0 ? void 0 : validator.ownerAddress) || "", 8)
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center justify-between text-dark1",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "font-semibold flex items-center",
                                                children: "Referral Score"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "",
                                                children: (0,format/* numberWithCommas */.x6)((validator === null || validator === void 0 ? void 0 : validator.karatScore) || 0)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center justify-between text-dark1",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "font-semibold flex items-center",
                                                children: "Return"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "",
                                                children: [
                                                    (((validator === null || validator === void 0 ? void 0 : (ref2 = validator.stake) === null || ref2 === void 0 ? void 0 : ref2.apy) || 0) * 100).toFixed(2),
                                                    "% APY"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center justify-between text-dark1",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "font-semibold flex items-center",
                                                children: "Number of stakers"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "",
                                                children: (0,format/* numberWithCommas */.x6)(validator === null || validator === void 0 ? void 0 : (ref3 = validator.stake) === null || ref3 === void 0 ? void 0 : ref3.stakerAmount)
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    validator && /*#__PURE__*/ (0,jsx_runtime.jsx)(leaderboard_UserStakeCard, {
                        tokenId: validator.tokenId
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var staking_ValidatorStakeDrawer = (ValidatorStakeDrawer);


/***/ }),

/***/ 65416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ useDevice; }
/* harmony export */ });
/* harmony import */ var _mantine_hooks__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34065);

function useDevice() {
    var matches = (0,_mantine_hooks__WEBPACK_IMPORTED_MODULE_0__/* .useMediaQuery */ .a)("(max-width: 640px)");
    return {
        isMobile: matches
    };
}


/***/ })

}]);